/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Days_TapInputs */

const en_us2_profile_editors_days_tap = /** @type {(inputs: Profile_Editors_Days_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap the days you train`)
};

const pt_br2_profile_editors_days_tap = /** @type {(inputs: Profile_Editors_Days_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque nos dias em que você treina`)
};

const es_419_profile_editors_days_tap = /** @type {(inputs: Profile_Editors_Days_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca los días en que entrenas`)
};

const pt_pt2_profile_editors_days_tap = /** @type {(inputs: Profile_Editors_Days_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca nos dias em que treinas`)
};

const fr_fr2_profile_editors_days_tap = /** @type {(inputs: Profile_Editors_Days_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Touche les jours où tu t'entraînes`)
};

const de_de2_profile_editors_days_tap = /** @type {(inputs: Profile_Editors_Days_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe auf die Tage, an denen du trainierst`)
};

const it_it2_profile_editors_days_tap = /** @type {(inputs: Profile_Editors_Days_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca i giorni in cui ti alleni`)
};

/**
* | output |
* | --- |
* | "Tap the days you train" |
*
* @param {Profile_Editors_Days_TapInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_days_tap = /** @type {((inputs?: Profile_Editors_Days_TapInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Days_TapInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_days_tap(inputs)
	if (locale === "es-419") return es_419_profile_editors_days_tap(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_days_tap(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_days_tap(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_days_tap(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_days_tap(inputs)
	return en_us2_profile_editors_days_tap(inputs)
});
export { profile_editors_days_tap as "profile-editors.days_tap" }